import React, { useState, useEffect } from 'react';
import { browserHistory } from 'react-router'
import { useSnackbar } from 'notistack';
import { Pagination, STableLoader, PageLoader, DeletePopUp, EmptyCollection } from '../../shared_elements';
import { SettingsNavWrapper } from '../../elements'
import { PendingList } from '../components'
import { Table, TableBody, Paper, Grid, Button, TableHead, TableRow, TableCell } from '@material-ui/core';
import { globalGetService, globalPutService } from '../../../globalServices';
import { checkApiStatus } from '../../utils_v2';
import { trackActivity } from '../../../utils/mixpanel';
import { usePageTitleOffset } from '../../elements/CollapsibleSideNav';
const PendingUsers = ({}) => {
    const navTitleOffset = usePageTitleOffset('settingsNavCollapsed');
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [userInfo, setUserInfo] = useState({list:[], pagination:{}})
    const [userStatus, setUserStatus] = useState({modal:false, type:'', user:null})
    useEffect(() => {
        getPendingUsers({per_page:50},'skeletonLoader');
        trackActivity('Console Management', { page_title: 'Pending Users', event_type: 'Page Visit', event_desc: 'Pending Users Page Visited' })
    },[]);
    const getPendingUsers = (query, loaderType) => {
        loaderType === 'skeletonLoader'?setSkeletonLoader(true): setLoading(true)
        globalGetService(`console/invite-user-request/`, query)
        .then(response => {
            if(checkApiStatus(response)){
                setUserInfo(response.data.data)
            }
            loaderType === 'skeletonLoader'?setSkeletonLoader(false): setLoading(false)
        });
    }
    const onChangeUserStatus = () => {
        setLoading(true)
        globalPutService(`console/invite-user-request/${userStatus.user.slug}/`, {status : userStatus.type === 'Approve' ? 2:3})
        .then(response => {
            if(checkApiStatus(response)){
                enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                if(userStatus.type === 'Approve'){
                    browserHistory.push('/users/manage/' + response.data.data.slug);
                }else{
                    getPendingUsers({page:userInfo.pagination.page, per_page:userInfo.pagination.per_page}, 'pageLoader')
                }
                setUserStatus({modal:false, type:'', user:null})
            }
            setLoading(false)
        })
    }
    return(
        <section className='roles-management asset-tech-specs' style={{margin:'25px 0 0 75px'}}>
            <Paper elevation={0} className='tech-specs-card console-paper' style={{height: `${window.innerHeight - 89}px`}}>
            <SettingsNavWrapper />
            <div className='tech-specs-content' style={{padding: '10px'}}>
            <div>
                { skeletonLoader ? <STableLoader count={7} size={9} />: <>
                    <Paper square>
                        <div style={{height:`${(window.innerHeight - (userInfo.list.length ? 150 : 100)) - navTitleOffset}px`,overflow:'auto'}}>
                        <Table className='mui-table-format' stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, width: '80px' }}>Action(s)</TableCell>
                                    {['Name','Email','Contact Number','Designation','Description'].map((label, index) => <TableCell>{label}</TableCell>)}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {userInfo.list.length > 0 && userInfo.list.map((item,index) =>
                                    <PendingList 
                                        item={item}
                                        key={index}
                                        onEdit={(type)=> setUserStatus({modal:true, type:type, user:item})}
                                    />
                                )}
                            </TableBody>
                        </Table>
                         {!userInfo.list.length ? <div style={{textAlign:'center'}}><EmptyCollection title={'No records found'} /></div>:null}
                        </div>
                    </Paper>
                      <Paper square>
                         <Pagination 
                            pagination={userInfo.pagination}
                            onChangePage={(event, newPage) => getPendingUsers({page:newPage+1, per_page: userInfo.pagination.per_page}, 'pageLoader')}
                            onChangeRowsPerPage={(event) => getPendingUsers({page:1, per_page: event.target.value}, 'pageLoader')}
                         />
                        </Paper>
                    </>
                }
            </div>
            {userStatus.modal ?
                <DeletePopUp
                    modal={userStatus.modal} 
                    title={`${userStatus.type} Invite Request`}
                    content={`Are you sure, you want to ${userStatus.type.toLocaleLowerCase()}?`}
                    toggleModalFn={() => setUserStatus({modal:false, type:'',user:null})}
                    deleteRecordFn={() => onChangeUserStatus()}
                    confirmText="YES"
                />:null
            }
            { isLoading ? <PageLoader />:null}
            </div>
            </Paper>
        </section>
    )
}
export default PendingUsers;